import React from 'react'
import { Divider, csx } from '@vtex/admin-ui'

export const PackageDivider = () => {
  return (
    <Divider
      className={csx({
        marginLeft: '-$space-6',
        marginRight: '-$space-6',
        '@desktop': { position: 'relative', marginLeft: -4 },
      })}
    />
  )
}
